import { render } from "./NewVacancyPage.vue?vue&type=template&id=3488301e"
import script from "./NewVacancyPage.vue?vue&type=script&lang=js"
export * from "./NewVacancyPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__